import { PROFESSIONAL } from '../data/legal';
import { CONTACT } from '../data/insurance';

export const ProfessionalDetails = () => <>
  <h3 data-testid="legal-orias-heading">Immatriculation professionnelle</h3>
  <p data-testid="legal-orias-details">
    ASSURE MOI est immatriculée à l’ORIAS sous le numéro <strong>{PROFESSIONAL.orias}</strong>,
    en qualité de {PROFESSIONAL.category.toLowerCase()}.<br />
    L’attestation du {PROFESSIONAL.registrationAttestationDate} mentionne une inscription depuis le {PROFESSIONAL.registrationDate}
    {' '}et une échéance au {PROFESSIONAL.registrationEndDate}.
  </p>
  <p data-testid="legal-orias-verification">
    Pour consulter le statut actualisé, recherchez le numéro {PROFESSIONAL.orias} sur le{' '}
    <a href={PROFESSIONAL.oriasWebsite} target="_blank" rel="noopener noreferrer" data-testid="legal-orias-link">registre officiel de l’ORIAS</a>.
  </p>
  <h3 data-testid="legal-rcp-heading">Responsabilité civile professionnelle — attestation fournie</h3>
  <p data-testid="legal-rcp-details">
    Organisme délivrant les garanties : {PROFESSIONAL.liability.insurer}.<br />
    Contrat n° {PROFESSIONAL.liability.policy}.<br />
    Période indiquée : du {PROFESSIONAL.liability.startsAt} au {PROFESSIONAL.liability.endsAt}.<br />
    Assuré désigné sur l’attestation : {PROFESSIONAL.liability.namedInsured}, avec le numéro ORIAS {PROFESSIONAL.orias}.
  </p>
  <p data-testid="legal-rcp-conditions">Les garanties s’appliquent dans les limites, conditions et exclusions du contrat. L’attestation précise que la police produit ses effets sous réserve du règlement intégral de la prime.</p>
  <h3 data-testid="legal-complaints-heading">Réclamations</h3>
  <p data-testid="legal-complaints-details">
    Pour une réclamation relative à votre accompagnement, contactez le cabinet à{' '}
    <a href={`mailto:${CONTACT.email}?subject=${encodeURIComponent('Réclamation — Assure Moi')}`} data-testid="legal-complaints-email">{CONTACT.email}</a>,
    en indiquant, si vous en disposez, votre référence de demande. Vous pouvez également écrire au siège social : 25 rue de Ponthieu, 75008 Paris.
  </p>
  <h3 data-testid="legal-mediation-heading">Médiation de la consommation</h3>
  <p className="legal-pending" data-testid="legal-mediation-pending">Le nom et les coordonnées du médiateur compétent restent à confirmer par le cabinet avant diffusion publique du site. Les attestations fournies ne précisent pas ces informations.</p>
  <h3 data-testid="legal-hosting-heading">Hébergement</h3>
  <p className="legal-pending" data-testid="legal-hosting-pending">L’identité et les coordonnées légales de l’hébergeur du site restent à compléter avant diffusion publique.</p>
</>;